import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";

import bg from '../../img/Landscape-Footer.jpg'
import {mixins} from "../../mixins";
import H from "../typography/H";
import Input from "../common/Input";
import Button from "../common/Button";


const Title = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
  align-items: stretch;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  margin-top: 20px;
  >*{
    &:last-child{
      justify-self: end;
    }
  }
`;

const Link = styled.a`
  color: ${p => p.theme.cWhite};
  display: inline-flex;
  align-items: center;
  
  &:hover, &:focus{
    color: ${p => p.theme.cWhite};
  }
`;

const LinkIcon = styled.div`
  font-size: ${p => p.theme.sIcon}px;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  background-color: ${p => p.theme.cWhite};
  color: ${p => p.theme.cAccent};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  margin-left: 10px;
  &:before{
    display: inline-block;
    text-decoration: none !important;
  }
`;

class Footer extends Component {
    render() {
        return (
            <footer className={this.props.className}>
                <div className="container">
                    <Title>
                        <H id={'footerTitle'} size={2} styleSize={2}>Подпишитесь на рассылку</H>
                    </Title>
                    <Form onSubmit={(e)=>{
                        console.log('submit');
                        e.preventDefault();
                    }} aria-labelledby={'footerTitle'}>
                        <Input fixedWidth noBorder placeholder={'Ваша эл. почта'}/>
                        <Button type={'submit'} label={'Подписаться'}/>
                    </Form>
                    <Row>
                        <div>© Все права защищены. 2018</div>
                        <div><Link href="javascript:void(0)">Terms and conditions</Link></div>
                        <div><Link href="javascript:void(0)">Developed by CG Ant<LinkIcon className="icon-social-fb"/></Link></div>
                    </Row>
                </div>
            </footer>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(Footer)`
  background-image: url(${bg});
  padding: 20px 0;
  ${mixins.fitBg()};
  color: ${p => p.theme.cWhite};
`));